import './Modal.css';
import { CloseButton } from '../CloseButton/CloseButton';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import SectionTitle from '../SectionTitle/SectionTitle';
import ReactDOM from 'react-dom';

type Props = {
  modalTitle: string,
  canClose: boolean,
  fn?: () => void,
  onClose?: () => void,
  children: JSX.Element,
  /** Wider modal for dense forms (e.g. sale step overview). */
  variant?: 'default' | 'wide',
};

export function Modal({
  modalTitle = '',
  canClose = true,
  onClose = () => null,
  children,
  variant = 'default',
}: Props) {

  const { t } = useTranslation();

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = 'unset' };
  }, []);

  const overlayClass = variant === 'wide' ? 'modalOverlay modalOverlayWide' : 'modalOverlay';
  const containerClass = variant === 'wide' ? 'modalContainer modalContainerWide' : 'modalContainer';

  const modalContent = (
    <div className={overlayClass}>
      <div className={containerClass}>
        <div className="modalHeader">
          <SectionTitle text={t(modalTitle)} />
          {canClose && <CloseButton fn={onClose} />}
        </div>
        <div className="modalBody">{children}</div>
        {/* <div className="modalFooter"></div> */}
      </div>
    </div>
  );

  const modalRoot = document.getElementById("modal-root");
  
  if (!modalRoot) {
    return null;
  }

  return ReactDOM.createPortal(modalContent, modalRoot);
}
